import { autoinject } from 'aurelia-framework';
import { AircraftDetailBaseView } from 'General/Views/Dynamic/AircraftDetail/AircraftDetailBaseView';

@autoinject
export class DetailView extends AircraftDetailBaseView { 
    
}